<template>
    <div>
        <h1>RENJA PENERIMAAN</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
